/**
 * @typedef {{
 *  ROUTE_CHANGE: 'app:route_change',
 *  URL_UPDATED: 'app:url_updated',
 *  PAGE_LOAD: 'load',
 *  POPSTATE: 'popstate',
 *  TOAST: 'app:toast'
 *  GLOBALS_UPDATED: 'app:globals-updated',
 *  HAS_TOOLBAR: 'app:has-toolbar',
 *  SHOW_WC_WALLET_MODAL: 'wallet-connect:show-wallet-modal'
 *  SHOW_WC_NETWORK_MODAL: 'wallet-connect:show-network-modal'
 *  WC_WALLET_CONNECTED: 'wallet-connect:wallet-connected'
 *  WALLET_SELECTOR_CLICKED: 'app:open-wallet-selector-clicked',
 * }} AppEvents
 */

/** @type {AppEvents} */
const AppEvents = {
  ROUTE_CHANGE: 'app:route_change',
  URL_UPDATED: 'app:url_updated',
  PAGE_LOAD: 'load',
  POPSTATE: 'popstate',
  TOAST: 'app:toast',
  GLOBALS_UPDATED: 'app:globals-updated',
  HAS_TOOLBAR: 'app:has-toolbar',
  SHOW_WC_WALLET_MODAL: 'wallet-connect:show-wallet-modal',
  SHOW_WC_NETWORK_MODAL: 'wallet-connect:show-network-modal',
  WC_WALLET_CONNECTED: 'wallet-connect:wallet-connected',
  WALLET_SELECTOR_CLICKED: 'app:open-wallet-selector-clicked',
}

export default AppEvents
